const STORAGE_KEY = 'b2b_global_header_search_recent';
const MAX_RECENT = 5;

function readAll() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : {};
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch {
    return {};
  }
}

function writeAll(data) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  } catch {
    /* ignore quota errors */
  }
}

/** @param {import('../config/globalHeaderSearch').SearchModuleId} moduleId */
export function getRecentSearches(moduleId) {
  const all = readAll();
  const rows = all[moduleId];
  return Array.isArray(rows) ? rows.filter((q) => typeof q === 'string' && q.trim()) : [];
}

/** @param {import('../config/globalHeaderSearch').SearchModuleId} moduleId */
export function pushRecentSearch(moduleId, query) {
  const trimmed = String(query || '').trim();
  if (!moduleId || trimmed.length < 2) return;

  const all = readAll();
  const prev = getRecentSearches(moduleId).filter((q) => q.toLowerCase() !== trimmed.toLowerCase());
  all[moduleId] = [trimmed, ...prev].slice(0, MAX_RECENT);
  writeAll(all);
}

export function clearRecentSearches(moduleId) {
  const all = readAll();
  if (moduleId) {
    delete all[moduleId];
  } else {
    Object.keys(all).forEach((key) => delete all[key]);
  }
  writeAll(all);
}
